import React from 'react';

const IntroText = ({contactPageCustomText}) => {
  if (!contactPageCustomText) return null;
  return (
    <p className="intro-text">
      {contactPageCustomText}
    </p>
  );
};

export default IntroText;



// WEBPACK FOOTER //
// ./src/components/contact/intro-text.js